const worker = new Worker('./timer.worker.js', { type: 'module' });

const send = message => worker.postMessage({
  message,
});

export default {
  worker,
  send,
};
